export default __webpack_public_path__ + "img/WB_RTK_NOMA_WF.8d4ed62831fb710444af99c178bcf9d8.jpg";